import { CalendarDays, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

export const todayIST = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

const shift = (date, days) => {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};

export const DateBar = ({ value, onChange, testId = "date-bar" }) => {
  const isAll = value === "all";
  const today = todayIST();
  const day = isAll ? today : value;
  return (
    <div className="flex flex-wrap items-center gap-1 rounded-md border border-slate-800 bg-[#111827] p-1.5" data-testid={testId}>
      <CalendarDays className="ml-1 h-4 w-4 text-slate-400" />
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={isAll} onClick={() => onChange(shift(day, -1))} data-testid={`${testId}-prev`} title="Previous day"><ChevronLeft className="h-4 w-4" /></Button>
      <Input type="date" value={day} max={today} onChange={(e) => e.target.value && onChange(e.target.value)} disabled={isAll}
        data-testid={`${testId}-input`} className={cn("h-8 w-40 border-slate-700 bg-slate-950 font-mono text-xs", isAll && "opacity-50")} />
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={isAll || day >= today} onClick={() => onChange(shift(day, 1))} data-testid={`${testId}-next`} title="Next day"><ChevronRight className="h-4 w-4" /></Button>
      <Button size="sm" variant={!isAll && day === today ? "default" : "ghost"} className={cn("h-8 text-xs", !isAll && day === today && "bg-blue-600 hover:bg-blue-700")} onClick={() => onChange(today)} data-testid={`${testId}-today`}>Today</Button>
      <Button size="sm" variant={isAll ? "default" : "ghost"} className={cn("h-8 text-xs", isAll && "bg-blue-600 hover:bg-blue-700")} onClick={() => onChange(isAll ? today : "all")} data-testid={`${testId}-all`}>All dates</Button>
    </div>
  );
};
